import React from 'react'

interface InternalProcessIconProps {
  color?: string
  secondaryColor?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const InternalProcessIcon: React.FC<InternalProcessIconProps> = ({
  color = '#000',
  secondaryColor = '#D9D9D9',
  gradient,
  width = 24,
  height = 23,
  alt = 'Internal process icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 23'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M7 6.754H1a1 1 0 00-1 1v13.5a1 1 0 001 1h22a1 1 0 001-1v-13.5a1 1 0 00-1-1h-6v1.25h5.75v13H1.25v-13H7v-1.25z'
        clipRule='evenodd'
      />
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M12 11.004a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zm0 1.25a3 3 0 100-6 3 3 0 000 6z'
        clipRule='evenodd'
      />
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M12 8.129c.345 0 .625.28.625.625v1a.625.625 0 11-1.25 0v-1c0-.345.28-.625.625-.625z'
        clipRule='evenodd'
      />
      <path
        fill={gradient ? 'url(#grad1)' : secondaryColor}
        fillRule='evenodd'
        d='M6 5.004l1.053-1.25h9.894L18 5.004H6z'
        clipRule='evenodd'
      />
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M6 5.004h12l-1.053-1.25H7.053L6 5.004z'
        clipRule='evenodd'
      />
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M16.75 21.003V4.868l-5.188-3.556L7.25 4.805v16.198h9.5zm.25 1.25H7a1 1 0 01-1-1V4.686a1 1 0 01.37-.777L10.92.223a1 1 0 011.195-.048l5.45 3.736a1 1 0 01.435.825v16.517a1 1 0 01-1 1zM19.85 10.954v.6h1.1v-.6h-1.1zm-.2-1.2a1 1 0 00-1 1v1a1 1 0 001 1h1.5a1 1 0 001-1v-1a1 1 0 00-1-1h-1.5zM19.85 15.954v.6h1.1v-.6h-1.1zm-.2-1.2a1 1 0 00-1 1v1a1 1 0 001 1h1.5a1 1 0 001-1v-1a1 1 0 00-1-1h-1.5zM3.05 10.954v.6h1.1v-.6h-1.1zm-.2-1.2a1 1 0 00-1 1v1a1 1 0 001 1h1.5a1 1 0 001-1v-1a1 1 0 00-1-1h-1.5zM3.05 15.954v.6h1.1v-.6h-1.1zm-.2-1.2a1 1 0 00-1 1v1a1 1 0 001 1h1.5a1 1 0 001-1v-1a1 1 0 00-1-1h-1.5z'
        clipRule='evenodd'
      />
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M13.75 16.754a1.75 1.75 0 10-3.5 0v4.25h3.5v-4.25zm-1.75-3a3 3 0 013 3v5.5H9v-5.5a3 3 0 013-3z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default InternalProcessIcon
